import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Building2 } from 'lucide-react';
import agencyImagesApi from '../../lib/agencyImagesApi';

/*
 * Agency logos for the Accounts surfaces — same store the GAS account
 * header and the Home card grid draw from (backend agency image
 * library, bulk-resolved via /api/agencies/images/defaults).
 */

// department_id → default logo URL for a set of visible agencies. One
// bulk call keyed by the id set; logos are best-effort, so failures
// just leave the map empty and badges fall back to the acronym.
export function useAgencyLogos(ids) {
  const key = (ids || []).filter(Boolean).join(',');
  const q = useQuery({
    queryKey: ['agency-logo-defaults', key],
    queryFn: () => agencyImagesApi.defaults(key.split(',').map(Number)),
    enabled: key.length > 0,
    staleTime: 6 * 60 * 60 * 1000,
    retry: false,
  });
  return q.data?.defaults || {};
}

// Logo with graceful fallback to the acronym badge (same contract as
// Home's CardLogo: both render into the same slot, a broken/missing
// image reverts to the badge, no layout shift).
export function AgencyLogo({ url, acronym, badgeClass, logoClass }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [url]);
  if (url && !broken) {
    return (
      <span className={logoClass}>
        <img src={url} alt="" loading="lazy" onError={() => setBroken(true)} />
      </span>
    );
  }
  return <span className={badgeClass}>{acronym || <Building2 size={16} />}</span>;
}
